import ReportSection from '../../containers/ReportSection';

export default class TableOfContents extends ReportSection {
  render() {
    return this.textarea('report_distribution');
  }
}
